import { TimelineCategory } from './types';

export const getCategoryColor = (category: TimelineCategory): string => {
  switch (category) {
    case 'milestone': return 'bg-blue-500';
    case 'award': return 'bg-purple-500';
    case 'recognition': return 'bg-green-500';
    default: return 'bg-gray-500';
  }
};